/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK — Student Club mock data
 * Fake clubs for the entry form. Will be replaced by API later.
 * ══════════════════════════════════════════════════════════════════════════ */

export const STUDENT_CLUBS = [
  { slug: 'koebenhavn-studenterklub',  name: 'København Studenterklub' },
  { slug: 'aarhus-studenterforening',  name: 'Aarhus Studenterforening' },
  { slug: 'odense-fredagsbar',         name: 'Odense Fredagsbar' },
  { slug: 'aalborg-studenterhus',      name: 'Aalborg Studenterhus' },
  { slug: 'roskilde-studenterklub',    name: 'Roskilde Studenterklub' },
  { slug: 'esbjerg-ungdomsforening',   name: 'Esbjerg Ungdomsforening' },
  { slug: 'vejle-studentrad',          name: 'Vejle Studenterråd' },
  { slug: 'kolding-studenterklub',     name: 'Kolding Studenterklub' },
];

export const getStudentClub = (slug) =>
  STUDENT_CLUBS.find((c) => c.slug === slug) || null;
